// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialAccountManager_root__z8NWi","confirm":"SocialAccountManager_confirm__AValh"};